import { HelpOutlined, OpenInNew } from '@mui/icons-material'
import { Box, Link, Stack } from '@mui/material'
import Paper from '@mui/material/Paper'
import { useTranslation } from 'react-i18next'

import CustomTypography from '@/components/dataDisplay/CustomTypography'

export function AppJsonInfoPanel() {
  const { t } = useTranslation()

  return (
    <Paper sx={{ p: 3, marginBottom: 2 }}>
      <Stack spacing={2}>
        <Stack alignItems="center" direction="row" spacing={1}>
          <HelpOutlined />
          <CustomTypography sx={{ mb: 2 }} variant="h3">
            {t('controllers.configuration.app_json.info.label')}
          </CustomTypography>
        </Stack>
        <CustomTypography sx={{ whiteSpace: 'pre-wrap' }}>
          {t('controllers.configuration.app_json.info.text')}
        </CustomTypography>
        <Box>
          <CustomTypography color="grey.500" variant="caption">
            Protocol buses
          </CustomTypography>
          <CustomTypography sx={{ whiteSpace: 'pre-wrap' }}>{`• Modbus/TCP (host, port)
• Modbus/RTU (serial port, baud rate, line mode)`}</CustomTypography>
        </Box>
        <Box>
          <CustomTypography color="grey.500" variant="caption">
            Power meter settings
          </CustomTypography>
          <CustomTypography
            sx={{ whiteSpace: 'pre-wrap' }}
          >{`• Metering for Schneider, Algodue and Accuenergy Accuvim II models
• Moving average
• Reporting (e.g. on significant difference)
• Value interpretation (absolute, adjust, multiply)
• Bus reference and Modbus unit id (Accuvim II)`}</CustomTypography>
        </Box>
        <Box>
          <CustomTypography color="grey.500" variant="caption">
            Batteries
          </CustomTypography>
          <CustomTypography
            sx={{ whiteSpace: 'pre-wrap' }}
          >{`• NW battery (id, bus reference, operating mode)`}</CustomTypography>
        </Box>
        <Stack alignItems="center" direction="row" spacing={1}>
          <OpenInNew />
          <Link
            href="https://app.notion.com/p/sympower/Configuration-options-of-app-json-25e28c3d46fa80eca3c1de9552eb5b47"
            rel="noopener noreferrer"
            sx={{ textDecoration: 'underline', background: 'none', border: 'none' }}
            target="_blank"
          >
            {t('controllers.configuration.app_json.info.notion_link_description')}
          </Link>
        </Stack>
      </Stack>
    </Paper>
  )
}
